import {
	getSession,
} from 'Vulture/Session.js';

// Sparkie rollout flag. Rolled out to ALL logged-in users (was internal-only
// iu/ia during the QA soak). When enabled, Sparkie is the chat surface for this
// user and the Salesforce floating widget is NOT initialized (so there's a
// single chat entry point, not two). A session is still required — the panel
// needs it for the identity token and per-user chat storage.
export const sparkieEnabled = () => {
	return !!getSession();
};
